import { Carousel } from '@mantine/carousel';
import { ReactNode } from 'react';

export const ZorroCarouselSlide = ({ children }: { children: ReactNode }) => {
  return <Carousel.Slide>{children}</Carousel.Slide>;
};
